import BookingCheckout, {
  CreditTypesEnum,
} from '../../../shared/BookingCheckout';
import './purchase-subscription-form.scss';
import { useTranslation } from 'react-i18next';
import SubscriptionFormInfo from './SubscriptionFormInfo';
import PurchaseSubscriptionFormActions from './PurchaseSubscriptionFormActions';
import ShowPolicyButton from '../../book-events/BookEventForm/ShowPolicyButton';
import { SubscriptionManagement } from '../../../../store/SubscriptionsManagement/subscriptionsManagementTypes';

type PropsTypes = {
  subscription: SubscriptionManagement;
  onBookEvent: () => Promise<void>;
  onSwitchShowPolicy: () => void;
  showPolicy: boolean;
};

const PurchaseSubscriptionForm = ({
  subscription,
  onBookEvent,
  onSwitchShowPolicy,
  showPolicy,
}: PropsTypes) => {
  const { t } = useTranslation();

  const categories = subscription.categoryObjects.map((category, index) => {
    return `${category.name}`;
  });

  return (
    <div className="purchase-subscription-form">
      <div className="purchase-subscription-form-content">
        <SubscriptionFormInfo
          title={t('SUBSCRIPTION_DETAILS_TITLE')}
          price={subscription.price}
          fromDate={new Date(+subscription.fromDate).toLocaleDateString()}
          toDate={new Date(+subscription.toDate).toLocaleDateString()}
          categories={categories.toString()}
        />
        <div className="purchase-subscription-empty-space"></div>
        <BookingCheckout
          creditTypes={CreditTypesEnum.USER}
          price={+subscription.price}
          disabledCreditUser={true}
        />
        <PurchaseSubscriptionFormActions onPurchaseSubscription={onBookEvent} />
        <ShowPolicyButton
          showPolicy={showPolicy}
          onSwitchShowPolicy={onSwitchShowPolicy}
        />
      </div>
    </div>
  );
};

export default PurchaseSubscriptionForm;
